import React, { ReactNode } from 'react';
import clsx from 'clsx';
import Label from 'components/common/label';

type Props = {
  className?: string;
  labelClasses?: string;
  containerClassName?: string;
  id: string;
  label?: string | ReactNode;
  required?: boolean;
  children?: ReactNode;
  error?: boolean;
  errorText?: string;
  showErrorText?: boolean;
};

function Wrapper({
  className,
  labelClasses,
  containerClassName,
  id,
  label,
  required,
  children,
  error,
  errorText,
  showErrorText = true,
}: Props) {
  const classes = clsx(
    'flex flex-col space-y-0.5 relative',
    className,
    { 'has-error': error },
  );

  const containerClasses = clsx(
    'w-full relative flex',
    containerClassName,
  );

  return (
    <div className={classes}>
      {typeof label === 'string' ? (
        <Label
          className={labelClasses}
          id={id}
          required={required}
        >
          {label}
        </Label>
      ) : label}
      {error && showErrorText && (
        <span className="absolute right-0 !text-xs text-red-500 font-semibold top-1">
          {errorText ?? 'Invalid entry'}
        </span>
      )}
      <div
        role="button"
        tabIndex={-1}
        className={containerClasses}
      >
        {children}
      </div>
    </div>
  );
}

export default Wrapper;
